export interface IMove {
    customerName: string;
    customerEmail: string;
    commissionAmount: string;
    commissionPercentage: string;
    customerDiscountAmount: string;
    customerDiscountPercentage: string;
    donationAmount: string;
    donationPercentage: string;
    rating: string;
    customerID: string;
    cID: string;
    totalMoveCost: string;
    moveStatus: MoveStatusEnum;
    paymentStatus: MovePaymentStatusEnum
    dateCreated: string;
    dateUpdated: string;
    reviewComment: string;
}


export enum MoveStatusEnum {
    NEW = "New",
    FOLLOW_UP = "Follow-up",
    QUOTED = "Quoted",
    PENCILED_IN = "Penciled In",
    BOOKED = "Booked",
    CONFIRMED = "Confirmed",
    COMPLETED = "Completed",
    CANCELLED = "Cancelled",
}

export enum MovePaymentStatusEnum {
    BOOKED = "Booked",
    PAID_OUT = "Paid Out",
    PAYMENT_PENDING = "Payment Pending",
    IN_PROGRESS = "In Progress",
    NOT_EARNED = "Not Earned",
    CANCELLED = "Cancelled/No",
    NEW = "New",
}
